import { render, staticRenderFns } from "./ExternalPaymentRedirect.vue?vue&type=template&id=40826b96"
import script from "./ExternalPaymentRedirect.vue?vue&type=script&lang=js"
export * from "./ExternalPaymentRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports